var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "formula-formulate-adapter" },
    [
      _vm._t(
        "form",
        function () {
          return [
            _c(
              "formulate-form",
              {
                key: _vm.formulateKey,
                ref: "form",
                attrs: { validation: "required" },
                model: {
                  value: _vm.input,
                  callback: function ($$v) {
                    _vm.input = $$v
                  },
                  expression: "input",
                },
              },
              [
                _c(
                  "div",
                  { staticClass: "flex gap-4 flex-col" },
                  [
                    _vm._l(_vm.fieldDefinitions, function (field) {
                      return [
                        field.type !== "group"
                          ? _c("formulate-field-adapter", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.shouldShow(field.name),
                                  expression: "shouldShow(field.name)",
                                },
                              ],
                              key: field.name,
                              attrs: { disabled: _vm.viewOnly, value: field },
                              on: { mounted: _vm.loadFieldRef },
                            })
                          : _c("formulate-group-adapter", {
                              key: field.name,
                              attrs: {
                                disabled: _vm.viewOnly,
                                debug: _vm.debug,
                                value: field,
                                "show-criteria": _vm.showCriteria,
                              },
                              on: { "mounted-field": _vm.loadFieldRef },
                            }),
                      ]
                    }),
                  ],
                  2
                ),
              ]
            ),
          ]
        },
        { fieldDefinitions: _vm.fieldDefinitions }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }